export default function Footer() {
  return (
    <footer id="iletisim" className="bg-gradient-to-b from-[#1E293B] to-[#0F172A] mx-10 mb-10 rounded-t-[32px] relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-10 overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#2563EB] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#0EA5E9] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-8 py-20 relative z-10">
        {/* Footer Columns */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-12">
          {/* Column 1 - Brand */}
          <div className="notion-fade-in">
            <h3 className="text-white text-3xl font-bold mb-4">DocAI</h3>
            <p className="text-[#94A3B8] text-[15px] leading-relaxed">
              Yapay zeka destekli belge doğrulama ve otomasyon platformu
            </p>
          </div>

          {/* Column 2 - Solutions */}
          <div className="notion-fade-in" style={{ animationDelay: '0.1s' }}>
            <h4 className="text-white text-lg font-semibold mb-6">Çözümler</h4>
            <ul className="space-y-4">
              {[
                'Gümrük Doğrulama',
                'Stok Yönetimi',
                'Belge Otomasyonu',
                'Risk Analizi',
                'Entegrasyon API'
              ].map((item, idx) => (
                <li key={idx}>
                  <a href="#" className="text-[#94A3B8] text-base hover:text-[#2563EB] smooth-transition flex items-center gap-2 group">
                    <span className="opacity-0 group-hover:opacity-100 smooth-transition">→</span>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div className="notion-fade-in" style={{ animationDelay: '0.2s' }}>
            <h4 className="text-white text-lg font-semibold mb-6">İletişim</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-[#2563EB] text-lg"></i>
                <a href="mailto:demo@appsheet.com.tr" className="text-[#94A3B8] text-base hover:text-[#2563EB] smooth-transition">
                  demo@appsheet.com.tr
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-[#2563EB] text-lg"></i>
                <a href="tel:+905370102404" className="text-[#94A3B8] text-base hover:text-[#2563EB] smooth-transition">
                  +90 537 010 24 04
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - CTA */}
          <div className="notion-fade-in" style={{ animationDelay: '0.3s' }}>
            <p className="text-white text-base mb-4 leading-relaxed">
              Hemen başlayın ve operasyonlarınızı güvence altına alın
            </p>
            <button 
              onClick={() => window.open('https://wa.me/905370102404?text=Merhaba,%20bilgi%20almak%20istiyorum.', '_blank')}
              className="w-full bg-[#2563EB] text-white py-4 px-6 rounded-2xl text-[17px] font-semibold hover:bg-[#1d4ed8] smooth-transition flex items-center justify-center gap-2 whitespace-nowrap group hover:shadow-lg"
            >
              İletişime Geçin
              <i className="ri-arrow-right-line group-hover:translate-x-1 smooth-transition"></i>
            </button>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#94A3B8] text-sm text-center md:text-left">
              © 2026 DocAI Technologies. Tüm hakları saklıdır.
            </p>

          </div>
        </div>
      </div>
    </footer>
  );
}
